import React, { useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { useJsApiLoader } from "@react-google-maps/api";
import { API_GOOGLE_KEY } from "..";

const MasterLayout = ({ children }) => {

  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const [sidebarActive, setSidebarActive] = useState(() => {
    const storedValue = localStorage.getItem("sideBarActive");
    return storedValue === null ? false : storedValue === "true";
  });
  useEffect(() => {
    // Function to handle dropdown clicks
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest('.dropdown');

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains('open');

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll('.sidebar-menu .dropdown');
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove('open');
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add('open');
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll('.sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link');

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener('click', handleDropdownClick);
    });

    // Function to open submenu based on current route
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll('.sidebar-menu .dropdown');
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll('.sidebar-submenu li a');
        submenuLinks.forEach((link) => {
          if (link.getAttribute('href') === location.pathname || link.getAttribute('to') === location.pathname) {
            dropdown.classList.add('open');
          }
        });
      });
    };

    // Open the submenu that contains the open route
    openActiveDropdown();



    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', handleDropdownClick);
      });

    };
  }, [location.pathname]);



  // Function to toggle sidebar and update localStorage
  const sidebarControl = () => {
    setSidebarActive((prev) => {
      const newValue = !prev;
      localStorage.setItem("sideBarActive", newValue.toString()); // Store as "true" or "false"
      
      return newValue;
    });
  };


  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };
  const getUser  = async ()=>{
    setCurrentUser(JSON.parse(localStorage.getItem('user')))
  }
  const [currentUser,setCurrentUser] = useState({})
   useEffect(()=>{
    getUser();
   },[1])

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
     {
      currentUser?.role == 'admin'?
      <aside className={sidebarActive ? "sidebar active " : mobileMenu ? "sidebar sidebar-open" : "sidebar"}>
      <button onClick={mobileMenuControl} type="button" className="sidebar-close-btn">
        <Icon icon="radix-icons:cross-2" />
      </button>
      <div>
        <Link to="/" className="sidebar-logo">
          <img
            src="assets/images/logo.png"
            alt="site logo"
            className="light-logo"
          />
          <img
            src="assets/images/logo-light.png"
            alt="site logo"
            className="dark-logo"
          />
          <img
            src="assets/images/logo-icon.png"
            alt="site logo"
            className="logo-icon"
          />
        </Link>
      </div>
      <div className="sidebar-menu-area">
        <ul className="sidebar-menu" id="sidebar-menu">
         <li>
            <NavLink  to="/" className={(navData) =>
              navData.isActive ? "active-page single"  : ""
            }>
                <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
              <span >Dashboard</span>
            </NavLink>
          </li>
          <li className="dropdown">
           <Link to="#">
             <Icon icon="flowbite:users-group-outline" className="menu-icon" />
             <span>Affiliates Management</span>
           </Link>
           <ul className="sidebar-submenu">
             <li>
               <NavLink to="/add-affiliates" 
               className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                  Add Affiliates
               </NavLink>
             </li>
             <li>
               <NavLink to="/sign-up-user/all" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                  All Affiliates
               </NavLink>
             </li>
            
             
           </ul>
         </li>
       
         <li>
               <NavLink to="/add-lead" className={(navData) =>
                 navData.isActive ? "active-page single" : ""
               }>
                <Icon icon="solar:home-smile-angle-outline" className="menu-icon" /><span>Assign Lead</span>
               </NavLink>
             </li>
             <li>
               <NavLink to="/leads" className={(navData) =>
                 navData.isActive ? "active-page single" : ""
               }>
                <Icon icon="solar:home-smile-angle-outline" className="menu-icon" /> <span>Leads List</span>
               </NavLink>
             </li>
        <li>
            <NavLink to="/search-company" 
            className={(navData) =>
              navData.isActive ? "active-page single" : ""
            }
            >
                <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
              <span>Search Company</span>
            </NavLink>
          </li>
       
           <li >
                <NavLink to="/create-user" className={(navData) =>
                  navData.isActive ? "active-page single" : ""
                }>
                   <Icon icon="solar:home-smile-angle-outline" className="menu-icon" /> 
                   <span>Add User</span>
                </NavLink>
             
             
          </li>
           <li >
           <NavLink to="/users" className={(navData) =>
                  navData.isActive ? "active-page single" : ""
                }>
                  <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
                  <span>Users List</span>
                </NavLink>
             
          </li>
          <li >
                <NavLink to="/tickets-for-admin" className={(navData) =>
                  navData.isActive ? "active-page single" : ""
                }>
                   <Icon icon="solar:home-smile-angle-outline" className="menu-icon" /> 
                   <span>Tickets</span>
                </NavLink>
             
             
          </li>
       
        </ul>
      </div>
    </aside>:
    currentUser?.role == 'user'?
     <aside className={sidebarActive ? "sidebar active " : mobileMenu ? "sidebar sidebar-open" : "sidebar"}>
     <button
      onClick={mobileMenuControl} 
     type="button" className="sidebar-close-btn">
       <Icon icon="radix-icons:cross-2" />
     </button>
     <div>
       <Link to="/" className="sidebar-logo">
         <img
           src="assets/images/logo.png"
           alt="site logo"
           className="light-logo"
         />
         <img
           src="assets/images/logo-light.png"
           alt="site logo"
           className="dark-logo"
         />
         <img
           src="assets/images/logo-icon.png"
           alt="site logo"
           className="logo-icon"
         />
       </Link>
     </div>
     <div className="sidebar-menu-area">
       <ul className="sidebar-menu" id="sidebar-menu">
       <li>
           <NavLink to="/" className={(navData) =>
             navData.isActive ? "active-page" : ""
           }>
               <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
             <span>Dashboard</span>
           </NavLink>

         </li>
     
       
      
         <li className="dropdown">
           <Link to="#">
             <Icon icon="flowbite:users-group-outline" className="menu-icon" />
             <span>Leads Management</span>
           </Link>
           <ul className="sidebar-submenu">
             <li>
               <NavLink to="/add-lead" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-primary-600 w-auto" /> Lead Job
               </NavLink>
             </li>
             <li>
               <NavLink to="/leads/all" className={(navData) =>
                 navData.isActive ? "active-page single" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" /> Leads List
               </NavLink>
             </li>
             
           </ul>
         </li>
      
        <li>
          <NavLink to="/search-company" 
            className={(navData) =>
              navData.isActive ? "active-page" : ""
            }
            >
                <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
              <span>Search Company</span>
            </NavLink>
          </li>
      
       
         
      
       </ul>
     </div>
   </aside>:
   <aside className={sidebarActive ? "sidebar active " : mobileMenu ? "sidebar sidebar-open" : "sidebar"}>
     <button onClick={mobileMenuControl} type="button" className="sidebar-close-btn">
       <Icon icon="radix-icons:cross-2" />
     </button>
     <div>
       <Link to="/" className="sidebar-logo">
         <img
           src="assets/images/logo.png"
           alt="site logo"
           className="light-logo"
         />
         <img
           src="assets/images/logo-light.png"
           alt="site logo"
           className="dark-logo"
         />
         <img
           src="assets/images/logo-icon.png"
           alt="site logo"
           className="logo-icon"
         />
       </Link>
     </div>
     <div className="sidebar-menu-area">
       <ul className="sidebar-menu" id="sidebar-menu">
       <li id="dashboard">
           <NavLink to="/" className={(navData) =>
             navData.isActive ? "active-page single" : ""
           }>
               <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
             <span>Dashboard</span>
           </NavLink>
         </li>
      
        
       
      
         <li className="dropdown" id="jobs-section">
           <Link to="#">
             <Icon icon="flowbite:truck-outline" className="menu-icon" />
             <span>Dispatch</span>
           </Link>
           <ul className="sidebar-submenu">
            
             <li>
               <NavLink to="/add-lead" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" /> Add Job
               </NavLink>
             </li>
             <li>
               <NavLink to="/leads" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />All Jobs
               </NavLink>
             </li>
             <li>
               <NavLink to="/leads/quotes" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Quotes
               </NavLink>
             </li>
             
           </ul>
         </li>
         <li className="dropdown" id="add-truck-btn">
           <Link to="#">
             <Icon icon="flowbite:truck-outline" className="menu-icon" />
             <span>Trucks</span>
           </Link>
           <ul className="sidebar-submenu">
            
             <li>
               <NavLink to="/trucks" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Trucks
               </NavLink>
             </li>
             <li>
              <NavLink to="/truck/location" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                   <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Track Truck
              </NavLink>
            </li>
             <li>
               <NavLink to="/truck-assignment" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Truck Assignments
               </NavLink>
             </li>
            
             
           </ul>
         </li>
         <li className="dropdown" id="add-truck-btns">
           <Link to="#">
             <Icon icon="flowbite:user-outline" className="menu-icon" />
             <span>Staff</span>
           </Link>
           <ul className="sidebar-submenu">
            
             <li>
               <NavLink to="/add-staff" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Add Staff
               </NavLink>
             </li>
             <li>
              <NavLink to="/staff" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                   <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Staff
              </NavLink>
            </li>
             
            
             
           </ul>
         </li>

         <li className="dropdown" id="add-truck-btns">
           <Link to="#">
             <Icon icon="flowbite:user-outline" className="menu-icon" />
             <span>Attendance</span>
           </Link>
           <ul className="sidebar-submenu">
            
             <li>
               <NavLink to="/time-sheet" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Timesheet
               </NavLink>
             </li>
             <li>
              <NavLink to="/manual-attendance" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                   <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Add Manual 
              </NavLink>
            </li>
             
            
             
           </ul>
         </li>
         <li id="timeoff">
           <NavLink to="/time-off" className={(navData) =>
             navData.isActive ? "active-page single" : ""
           }>
               <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
             <span>Time Off</span>
           </NavLink>
         </li>
         <li id="timeoff">
           <NavLink to="/request" className={(navData) =>
             navData.isActive ? "active-page single" : ""
           }>
               <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
             <span>Request</span>
           </NavLink>
         </li>
         <li id="payroll">
           <NavLink to="/payroll" className={(navData) =>
             navData.isActive ? "active-page single" : ""
           }>
              <Icon icon="flowbite:dollar-outline" className="menu-icon" />
             <span>Payroll</span>
           </NavLink>
         </li>
 
       
         
         <li className="dropdown">
           <Link to="#">
             <Icon icon="mdi:file-document-outline" className="menu-icon" />
             <span>Invoices</span>
           </Link>
           <ul className="sidebar-submenu">
            
             <li>
               <NavLink to="/add-invoice" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Add Invoice
               </NavLink>
             </li>
             <li>
               <NavLink to="/invoices" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" /> Invoices
               </NavLink>
             </li>
             
           </ul>
         </li>
         
         <li className="dropdown">
           <Link to="#">
             <Icon icon="flowbite:truck-outline" className="menu-icon" />
             <span>Maintenance</span>
           </Link>
           <ul className="sidebar-submenu">
            
             <li>
               <NavLink to="/vehicle-default" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Vehicle Default
               </NavLink>
             </li>
             <li>
               <NavLink to="/schedule-maintenance" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Schedule Maintenance
               </NavLink>
             </li>
             <li>
               <NavLink to="/maintenance-logs" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Maintenance Logs
               </NavLink>
             </li>
             
           </ul>
         </li>
         <li className="dropdown">
           <Link to="#">
             <Icon icon="flowbite:cog-outline" className="menu-icon" />
             <span>Accounts</span>
           </Link>
           <ul className="sidebar-submenu">
           <li>
               <NavLink to="/expense" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Expenses
               </NavLink>
             </li>
           <li>
               <NavLink to="/create-expense" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Create Expense
               </NavLink>
             </li>
             <li>
               <NavLink to="/accounts" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Expense Accounts
               </NavLink>
             </li>
             <li>
           <NavLink to="/reports" className={(navData) =>
             navData.isActive ? "active-page single" : ""
           }>
              <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Reports
           </NavLink>
         </li>
            
           
            
             
           </ul>
         </li>
         <li className="dropdown">
           <Link to="#">
             <Icon icon="flowbite:cog-outline" className="menu-icon" />
             <span>Setting</span>
           </Link>
           <ul className="sidebar-submenu">
            
             <li>
               <NavLink to="/settings/profile" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Profile
               </NavLink>
             </li>
             <li>
               <NavLink to="/locations" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Locations
               </NavLink>
             </li>
             <li>
               <NavLink to="/departments" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Departments
               </NavLink>
             </li>
             <li>
               <NavLink to="/work-schedule" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Work Schedule
               </NavLink>
             </li>
             <li>
               <NavLink to="/settings/integration" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" /> Integration
               </NavLink>
             </li>
             
           </ul>
         </li>
         <li className="dropdown" id="jobs-section">
           <Link to="#">
             <Icon icon="mdi:headset" className="menu-icon" />
             <span>Support</span>
           </Link>
           <ul className="sidebar-submenu">
            
             <li>
               <NavLink to="/open-ticket" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" /> Open Ticket
               </NavLink>
             </li>
             <li>
               <NavLink to="/tickets" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Tickets
               </NavLink>
             </li>
             {/* <li>
               <NavLink to="/live-chat" className={(navData) =>
                 navData.isActive ? "active-page" : ""
               }>
                 <i className="ri-circle-fill circle-icon text-warning-main w-auto" />Live Chat
               </NavLink>
             </li> */}
            
             
           </ul>
         </li>
         
        
            
      
      
      
       
         
      
       </ul>
     </div>
   </aside>
     }

      <main className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button type="button" className="sidebar-toggle" onClick={sidebarControl}>
                  {
                    sidebarActive ? (<Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />) : (<Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />)
                  }
                </button>
                <button onClick={mobileMenuControl} type="button" className="sidebar-mobile-toggle">
                  <Icon
                    icon="heroicons:bars-3-solid"
                    className="icon"
                  />
                </button>
                {/* <form className="navbar-search">
                  <input type="text" name="search" placeholder="Search" />
                  <Icon icon="ion:search-outline" className="icon" />
                </form> */}
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                {/* ThemeToggleButton */}
                {/* <ThemeToggleButton /> */}
                {/* <div className="dropdown d-none d-sm-inline-block">
                  <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src="assets/images/lang-flag.png"
                      alt="Wowdash"
                      className="w-24 h-24 object-fit-cover rounded-circle"
                    />
                  </button>
                  {/* <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-0">
                          Choose Your Language
                        </h6>
                      </div>
                    </div>
                    <div className="max-h-400-px overflow-y-auto scroll-sm pe-8">
                      <div className="form-check style-check d-flex align-items-center justify-content-between mb-16">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="english"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag1.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              English
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="english"
                        />
                      </div>
                      <div className="form-check style-check d-flex align-items-center justify-content-between mb-16">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="japan"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag2.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              Japan
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="japan"
                        />
                      </div>
                      <div className="form-check style-check d-flex align-items-center justify-content-between mb-16">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="france"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag3.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              France
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="france"
                        />
                      </div>
                      <div className="form-check style-check d-flex align-items-center justify-content-between mb-16">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="germany"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag4.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              Germany
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="germany"
                        />
                      </div>
                      <div className="form-check style-check d-flex align-items-center justify-content-between mb-16">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="korea"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag5.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              South Korea
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="korea"
                        />
                      </div>
                      <div className="form-check style-check d-flex align-items-center justify-content-between mb-16">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="bangladesh"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag6.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              Bangladesh
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="bangladesh"
                        />
                      </div>
                      <div className="form-check style-check d-flex align-items-center justify-content-between mb-16">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="india"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag7.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              India
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="india"
                        />
                      </div>
                      <div className="form-check style-check d-flex align-items-center justify-content-between">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="canada"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag8.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              Canada
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="canada"
                        />
                      </div>
                    </div>
                  </div> 
                </div> */}
                {/* Language dropdown end */}
                
                 {/* <div className="dropdown">
                  <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Icon
                          icon="mdi:bell-outline" 
                            className="text-primary-light text-xl" width="24" height="24" 

                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-lg p-0">
                    <div className="m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-0">
                          Notifications
                        </h6>
                      </div>
                      <span className="text-primary-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center">
                        05
                      </span>
                    </div>
                    <div className="max-h-400-px overflow-y-auto scroll-sm pe-4">
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between"
                      >
                        <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                          <span className="w-40-px h-40-px rounded-circle flex-shrink-0 position-relative">
                            <img
                              src="assets/images/notification/profile-3.png"
                              alt=""
                            />
                            <span className="w-8-px h-8-px bg-success-main rounded-circle position-absolute end-0 bottom-0" />
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Kathryn Murphy
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-100-px">
                              hey! there i’m...
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <span className="text-sm text-secondary-light flex-shrink-0">
                            12:30 PM
                          </span>
                          <span className="mt-4 text-xs text-base w-16-px h-16-px d-flex justify-content-center align-items-center bg-warning-main rounded-circle">
                            8
                          </span>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between"
                      >
                        <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                          <span className="w-40-px h-40-px rounded-circle flex-shrink-0 position-relative">
                            <img
                              src="assets/images/notification/profile-4.png"
                              alt=""
                            />
                            <span className="w-8-px h-8-px  bg-neutral-300 rounded-circle position-absolute end-0 bottom-0" />
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Kathryn Murphy
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-100-px">
                              hey! there i’m...
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <span className="text-sm text-secondary-light flex-shrink-0">
                            12:30 PM
                          </span>
                          <span className="mt-4 text-xs text-base w-16-px h-16-px d-flex justify-content-center align-items-center bg-warning-main rounded-circle">
                            2
                          </span>
                        </div>
                      </Link> 
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between bg-neutral-50"
                      >
                        <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                          <span className="w-40-px h-40-px rounded-circle flex-shrink-0 position-relative">
                            <img
                              src="assets/images/notification/profile-5.png"
                              alt=""
                            />
                            <span className="w-8-px h-8-px bg-success-main rounded-circle position-absolute end-0 bottom-0" />
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Kathryn Murphy
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-100-px">
                              hey! there i’m...
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <span className="text-sm text-secondary-light flex-shrink-0">
                            12:30 PM
                          </span>
                          <span className="mt-4 text-xs text-base w-16-px h-16-px d-flex justify-content-center align-items-center bg-neutral-400 rounded-circle">
                            0
                          </span>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between bg-neutral-50"
                      >
                        <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                          <span className="w-40-px h-40-px rounded-circle flex-shrink-0 position-relative">
                            <img
                              src="assets/images/notification/profile-6.png"
                              alt=""
                            />
                            <span className="w-8-px h-8-px bg-neutral-300 rounded-circle position-absolute end-0 bottom-0" />
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Kathryn Murphy
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-100-px">
                              hey! there i’m...
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <span className="text-sm text-secondary-light flex-shrink-0">
                            12:30 PM
                          </span>
                          <span className="mt-4 text-xs text-base w-16-px h-16-px d-flex justify-content-center align-items-center bg-neutral-400 rounded-circle">
                            0
                          </span>
                        </div>
                      </Link>
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between"
                      >
                        <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                          <span className="w-40-px h-40-px rounded-circle flex-shrink-0 position-relative">
                            <img
                              src="assets/images/notification/profile-7.png"
                              alt=""
                            />
                            <span className="w-8-px h-8-px bg-success-main rounded-circle position-absolute end-0 bottom-0" />
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Kathryn Murphy
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-100-px">
                              hey! there i’m...
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <span className="text-sm text-secondary-light flex-shrink-0">
                            12:30 PM
                          </span>
                          <span className="mt-4 text-xs text-base w-16-px h-16-px d-flex justify-content-center align-items-center bg-warning-main rounded-circle">
                            8
                          </span>
                        </div>
                      </Link>
                    </div>
                   
                  </div>
                </div>  */}
                {/* Message dropdown end */}
                                {/* Notification dropdown end */}
                                <div>
                        <h6 className="text-sm text-primary-light fw-semibold mb-0">
                         {currentUser.role === 'admin' || currentUser.role =='user' ? currentUser?.name: currentUser?.business_name}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">{currentUser?.role === 'owner'? 'Manager' : currentUser?.role}</span>
                      </div>
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src="assets/images/favicon-2.png"
                      alt="image_user"
                      style={{borderWidth:1,borderColor:'#c0c0c0'}}
                      className="w-40-px h-40-px object-fit-cover b-1 rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                         {currentUser.role === 'admin' || currentUser.role =='user' ? currentUser?.name: currentUser?.business_name}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">{currentUser?.role === 'owner'? 'Manager' : currentUser?.role}</span>
                      </div>
               
                    </div>
                    <ul className="to-top-list">
                   
                   
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          // to="#"
                          onClick={()=>{
                            localStorage.removeItem('user');
                            window.location.href='/sign-in'
                          }}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" /> Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}

              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© 2024 TowRankers. All Rights Reserved.</p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Made by <span className="text-primary-600"><a target="_blank" rel="" href="https://unisoftwares.com">Unisoftwares</a></span>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
